import DropdownTemplateView from '../DropdownTemplateView'
import {showElementAt} from '../atBrowserUtils'
import $ from 'jquery'


export default class DropdownDialogWithPointerWrapper extends DropdownTemplateView {
    constructor({
        toggleMode = false,
        additionalClass = "",
        dialog,
        dialogOffsets = {
            left: 0,
            top: 0
        },
        pointerHorizontalAlignments = {
            my: "center",
            at: "center"
        },
        pointerLeftOffset = 0,
        onHide = () => {},
    }) {
        super(null, {
            toggleMode,
            onHide,
        })

        this.params = {
            ...this.params,
            additionalClass,
            dialog,
            pointerLeftOffset,
            dialogOffsets,
            pointerHorizontalAlignments,
        }
    }

    templateHtml() {
        return '<div class="dropdownDialogWithPointerWrapper <%=additionalClass%>">' +
               '  <div class="content"></div>' +
               '  <div class="pointer"></div>' +
               '</div>'
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }

    afterRender() {
        super.afterRender()

        this.$content = this.find('.content')
        this.$pointer = this.find('.pointer')
        this.params.dialog.init(this.$content)
        this.registerChildComponents(this.params.dialog)
    }

    showAt($element, positionParams = {}, $positionEl = $element) {
        super.showAt($element, {
            offset: `${this.params.dialogOffsets.left}px ${this.params.dialogOffsets.top}px`,
            ...positionParams
        }, $positionEl)
        this._adjustPointer($positionEl)
    }

    _adjustPointer($element) {
        this.getEl().removeClass("pointerAbove pointerBelow pointerLeft")

        const pointerHeight = this.$pointer.height()
        let pointerPositionParams = {}

        if (this.$el.offset().left > $element.offset().left) {
            this.$el.addClass("pointerLeft");
            const leftOffset = this.params.dialogOffsets.left - this.$pointer.width();
            pointerPositionParams = {
                my: "left center",
                at: "right center",
                of: $element,
                offset: leftOffset + "px " + 0 + "px"
            }
        }
        else if (this.$el.offset().top < $element.offset().top) {
            this.$el.addClass("pointerBelow")

            const topOffset = -($element.offset().top - this.$el.offset().top - this.$el.outerHeight() - pointerHeight)
            pointerPositionParams = {
                my: "center bottom",
                at: "center top",
                of: $element,
                offset: this.params.pointerLeftOffset + "px " + topOffset + "px"
            }
        } else {
            this.getEl().addClass("pointerAbove")

            const topOffset = this.$el.offset().top - $element.offset().top - $element.outerHeight() - pointerHeight
            pointerPositionParams = {
                my: "center top",
                at: "center bottom",
                of: $element,
                offset: this.params.pointerLeftOffset + "px " + topOffset + "px"
            }
        }

        showElementAt(this.$pointer, pointerPositionParams)
    }

    setState(state) {
        super.setState(state)
        this.applyForChildrenComponents(child => child.setState(state))
    }

    update() {
        super.update()
        this.applyForChildrenComponents(child => child.update())
    }

    mouseDownTargetElement() {
        return $('body')
    }
}



// WEBPACK FOOTER //
// ./web/js/components/DropdownDialogWithPointerWrapper.js